module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAAAR0lEQVQ4y+XTwQ0AIAwCQHBpZ3BqnEBobOJH/tyjpJSETgaaeQNwQdeAK0cglS1QKR+BavkIaILtFaqIPWIFiTMmhJ/8gssG8uITosSR4rEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/dataGrid/icon_left_shi.png
// module id = 2030
// module chunks = 50